<template>
  <main id="client-page">
    <ContentTitle
      :category="$t('sideMenu.Configuration')"
      :categoryIcon="'scf-diagnosys'"
      :title="$t('sideMenu.ClientManagement')"
      :helpUrl="'https://amrradiosupervision-dev.amr-integration.green.intra/'"
    />
    <div class="nav-header-content">
      <div>
        <nav class="navbar navbar-expand-lg" style="width: 100%">
          <div class="navbar-collapse">
            <ul
              class="navbar-nav mr-auto mt-2 mt-lg-0"
              id="myTab1"
              role="tablist"
              style="display: flex; width: 100%"
            >
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: tab == 1 }"
                  @click.prevent="showTab(1)"
                  role="tab"
                  aria-selected="true"
                  >{{ $t("pages.clientConfiguration.clientList") }}</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: tab == 2 }"
                  @click.prevent="showTab(2)"
                  role="tab"
                  aria-selected="true"
                  >{{ $t("pages.clientConfiguration.addNewClient") }}</a
                >
              </li>
            </ul>
          </div>
        </nav>

        <div class="tab-content">
          <div v-if="tab == 1" class="tab-pane fade in show active">

            <clientList v-if="showClientList"/>
            <clientDetails v-if="!showClientList && client" :client="client" />

          </div>
          <div v-if="tab == 2" class="tab-pane fade in show active">
            <section class="content main-client-list">
              <div class="row">
                <clientCreate @closeCreate="showTab(1, true)"/>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
        <modal
          :show="showQuitModal"
          @update:show="setQuitModal"
          :type="'notif'"
          :icon="'scf-Incident'"
          :title="quitModalTitle"
          :content="quitModalContent"
          :closeBtn="true"
          :actions="[{ cancel: cancelBtn }, { quit: quitWithoutSavingBtn }]"
        />
  </main>
</template>
<script>
import { defineComponent, computed } from "vue";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import Modal from "@supervision/vue-components/components/Modal";
import clientCreate from "./Create.vue";
import clientList from "./ClientList.vue";
export default defineComponent({
  provide() {
    return {
      updatePageChangeState: this.updateTochangePage,
      okToChangePage: this.okToChangePage,
    }
  },
  components: {
    ContentTitle,
    clientCreate,
    clientList,
    Modal,
  },
  data() {
    return {
      nextTarget: 0,
      tab: 1,
      showClientList: true,
      showQuitModal: false,
      nextPath: null,
      okToChangePage: {
        create: true,
        edit: true,
        details: true,
        confirm: () => this.okToChangePage.create && this.okToChangePage.edit && this.okToChangePage.details,
        forceOk: () => {
          this.okToChangePage.create = true;
          this.okToChangePage.edit = true;
          this.okToChangePage.details = true;
        },
      },
      quitModalContent: computed(() => this.$t("pages.Client.quitNewClient")),
      quitModalTitle: computed(() => this.$t("pages.Client.addClient")),
      cancelBtn: computed(() => this.$t("common.cancel")),
      quitWithoutSavingBtn: computed(() =>
        this.$t("pages.Client.quitWithoutSaving")
      ),
    };
  },
  methods: {
    setQuitModal(result) {
      if (result == "quit") {
        if (this.nextPath !== null) { // called from route change
          const next = this.nextPath;
          this.nextPath = null;
          return next();
        } else { // called from component unmount
          this.okToChangePage.forceOk();
          this.showQuitModal = false;
          this.showClientList = true;
          if (this.nextTarget == 2) {
            this.tab = 2;
          } else {
            this.tab = 1;
          }
          this.nextTarget = 0;
        }
      } else {
        this.showQuitModal = false;
        this.nextPath = null;
        return;
      }
    },
    updateTochangePage(okToChangePage) {
      this.okToChangePage = okToChangePage;
    },
    showTab(value, isForced = false) {
      if(value == 1){
        if (isForced || this.okToChangePage.confirm()) {
          this.showClientList = true;
          this.okToChangePage.forceOk();
        } else {
          this.showQuitModal = true;
          this.showClientList = false;
          return;
        }
      }else{
        if (this.okToChangePage.confirm()) {
          this.showClientList = false;
          this.okToChangePage.forceOk();
        } else {
          this.showQuitModal = true;
          this.nextTarget = 2;
          return;
        }
      }
      this.tab = value;
    },
    confirmPageChange(e) {
      const routeDetails = e.detail;
      // check if w can change page
      if(this.okToChangePage.confirm())
        return routeDetails.next();
      // otherwise display confirmation modal
        this.showQuitModal = true;
      // Now how to next() ?
      this.nextPath = routeDetails.next; 
      return;
    },
  },
  created() {
    window.addEventListener("amr-route-change", this.confirmPageChange);
  },
  beforeUnmount() {
    window.removeEventListener("amr-route-change", this.confirmPageChange);
  },
});
</script>

<style scoped src="../../assets/css/client.css"></style>
